// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementLocationSetsDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      tag_names: arrayOf(string),
      geofence_count: number,
      last_edited: number,
      archived: boolean,
    })
  ),
});
